<div class="card" style="max-width: 500px; padding:10px; margin-left:auto; margin-right: auto;">
  <div class="card-body">
    <p>
      För tillfället kan vi inte godkänna affärsförbindelsen med detta bolag. För mer information
      kontakta info@zaver.se
    </p>
  </div>
</div>
